
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import modalUtils from '../../../../../../../qti/utils/ModalUtils';

import DrawingCollapsedView from './DrawingCollapsedView';
import DrawingToolCkeditorModalWrapper from './DrawingToolCkeditorModalWrapper';
import DrawingService from '../../../../../../../services/DrawingService';


export class DrawingToolCkeditor extends React.Component {
    static propTypes = {
        ckeditor: PropTypes.object.isRequired, // the ckeditor instance
        closeCallback: PropTypes.func.isRequired,
        clickedDrawing: PropTypes.object,
        contentRevisionId: PropTypes.number.isRequired,
        questionTitle: PropTypes.string,
        questionNr: PropTypes.string,
        showDrawingTool: PropTypes.bool.isRequired,
        draftedDrawing: PropTypes.object,
        hasDraftedDrawing: PropTypes.bool,
    };

    constructor() {
        super();
        this.state = {
            expanded: false,
            hasManuallyMinimizedModal: false,
        };
    }

    // eslint-disable-next-line camelcase,react/sort-comp
    UNSAFE_componentWillMount() {
        Modal.setAppElement('body');
    }

    getDataUrlFromSelection = () => {
        if (this.props.draftedDrawing) {
            return this.props.draftedDrawing.toDataURL();
        } else if (this.state.inProgressDrawing) {
            return this.state.inProgressDrawing.toDataURL();
        } else if (this.props.clickedDrawing) {
            return this.props.clickedDrawing.getAttribute('src');
        }

        return undefined;
    };

    saveCallback = (drawing) => {
        if (drawing) {
            const dataURL = drawing.toDataURL();
            const { clickedDrawing, ckeditor } = this.props;
            if (clickedDrawing) {
                clickedDrawing.setAttribute('src', dataURL);
                // needs to update data-cke-saved-src to preserve changes in img src for ckeditor
                clickedDrawing.setAttribute('data-cke-saved-src', dataURL);
            } else {
                const imgString = `<p><img src="${dataURL}" class="ia-drawing"/></p>`;
                ckeditor.insertHtml(imgString);
            }
        }
        DrawingService.removeInProgressDrawing(this.props.contentRevisionId);
        this.props.closeCallback();
        this.setState({
            expanded: false,
            hasManuallyMinimizedModal: false,
        });
    };

    closeModal = () => {
        DrawingService.removeInProgressDrawing(this.props.contentRevisionId);
        this.props.closeCallback();
        this.setState({
            expanded: false,
        });
    };

    minimizeModal = (drawing) => {
        DrawingService.updateInProgressDrawings(this.props.contentRevisionId, drawing);
        this.setState({
            expanded: false,
            hasManuallyMinimizedModal: true,
        });
    };

    expandModal = () => {
        this.setState({
            expanded: true,
            hasManuallyMinimizedModal: false,
        });
    };

    render() {
        const shouldShowCollapsedView = DrawingService.shouldShowCollapsedView(this.props.hasDraftedDrawing, this.state.expanded);
        const shouldShowExpandedView = DrawingService.shouldShowExpandedView(this.state.expanded, this.props.showDrawingTool);

        if (shouldShowCollapsedView) {
            /*
             * If a drawing for this essay has been started
             * and the drawing modal was collapsed/minimized,
             * then render the collapsed view:
             */
            return (<DrawingCollapsedView
                inProgressDrawing={this.props.draftedDrawing}
                expandModal={this.expandModal}
                closeModal={this.closeModal}
                saveCallback={this.saveCallback}
                connectedDialog={DrawingService.getModalId(this.props.ckeditor)}
                shouldAutoFocus={this.state.hasManuallyMinimizedModal}
            />);
        } else if (shouldShowExpandedView) {
            /*
             * If the user has clicked "new drawing"
             * or they expanded a collapsed/minimized drawing,
             * then render the modal view:
             */
            return (
                <Modal
                    isOpen
                    style={modalUtils.drawingModalStyles}
                    role="dialog"
                    tabindex="0"
                    id={DrawingService.getModalId(this.props.ckeditor)}
                    contentLabel={DrawingService.getModalTitle(this.props.questionTitle, this.props.questionNr)}
                >
                    <DrawingToolCkeditorModalWrapper
                        saveCallback={this.saveCallback}
                        closeCallback={this.closeModal}
                        minimizeModal={this.minimizeModal}
                        dataUrlFromSelection={this.getDataUrlFromSelection()}
                        title={DrawingService.getModalTitle(this.props.questionTitle, this.props.questionNr)}
                    />
                </Modal>
            );
        }

        return null;
    }
}

function mapStateToProps(state, ownProps) {
    const inProgressDrawings = state.drawing.inProgressDrawings;

    const draftedDrawingObject = DrawingService.getInProgressDrawingForItem(ownProps.contentRevisionId, inProgressDrawings);
    const draftedDrawing = draftedDrawingObject?.drawing;
    const hasDraftedDrawing = !!draftedDrawingObject?.contentRevisionId;

    return {
        hasDraftedDrawing,
        draftedDrawing,
    };
}

const DrawingToolCkeditorWrapper = connect(mapStateToProps)(DrawingToolCkeditor);
export default DrawingToolCkeditorWrapper;
